import useId from '../utils/useId';
import * as React from 'react';
export const kdbBankSvg = React.forwardRef(function kdbBankSvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  const id_3 = baseId + '_3';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_kdbBank__a_${id_0})`,
      d: 'M8.218 9.958c-.47.934.01 2.86.602 3.788l8.162 12.81h-5.963c-.941 0-1.862-.538-2.266-1.158l-4.447-6.992c-.418-.653-.397-1.687 0-2.319l3.912-6.129Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_kdbBank__b_${id_1})`,
      d: 'M11.662 16.27c-.217.339-.413 1.146-.083 1.801l-2.756-4.325c-.595-.927-1.073-2.854-.602-3.788l.489-.768c.443-.701 1.266-1.16 2.307-1.16h5.863l-5.215 8.24h-.003Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_kdbBank__c_${id_2})`,
      d: 'M23.778 21.702c.47-.934-.01-2.86-.602-3.785l-8.16-12.81h5.964c.939 0 1.861.535 2.265 1.153l4.45 6.994c.417.651.397 1.684-.002 2.316L23.78 21.7l-.002.002Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_kdbBank__d_${id_3})`,
      d: 'M20.336 15.39c.217-.339.413-1.146.085-1.801l2.757 4.327c.595.926 1.073 2.854.602 3.786l-.489.768c-.443.701-1.266 1.16-2.304 1.16h-5.864l5.215-8.24h-.002Z',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_kdbBank__a_${id_0}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform: 'matrix(0 -15.8304 17.338 0 4.187 13.768)',
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#C7DFF4',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.07,
          stopColor: '#BFDBF2',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.17,
          stopColor: '#A9D0EE',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.25,
          stopColor: '#92C5EB',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.36,
          stopColor: '#7FB4E0',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.58,
          stopColor: '#4F89C3',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.7,
          stopColor: '#3471B3',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.82,
          stopColor: '#215EA0',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#003C7F',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_kdbBank__b_${id_1}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform: 'translate(17.942 8.196) scale(11.1333)',
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#C7DFF4',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.07,
          stopColor: '#BFDBF2',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.17,
          stopColor: '#A9D0EE',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.25,
          stopColor: '#92C5EB',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.36,
          stopColor: '#7FB4E0',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.58,
          stopColor: '#4F89C3',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.7,
          stopColor: '#3471B3',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.82,
          stopColor: '#215EA0',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#003C7F',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_kdbBank__c_${id_2}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform: 'matrix(0 15.8274 -17.3348 0 27.808 17.971)',
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#C7DFF4',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.07,
          stopColor: '#BFDBF2',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.17,
          stopColor: '#A9D0EE',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.25,
          stopColor: '#92C5EB',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.36,
          stopColor: '#7FB4E0',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.58,
          stopColor: '#4F89C3',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.7,
          stopColor: '#3471B3',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.82,
          stopColor: '#215EA0',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#003C7F',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_kdbBank__d_${id_3}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform: 'rotate(-180 7.062 11.742) scale(11.1344)',
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#C7DFF4',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.07,
          stopColor: '#BFDBF2',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.17,
          stopColor: '#A9D0EE',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.25,
          stopColor: '#92C5EB',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.36,
          stopColor: '#7FB4E0',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.58,
          stopColor: '#4F89C3',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.7,
          stopColor: '#3471B3',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.82,
          stopColor: '#215EA0',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#003C7F',
        }),
      ),
    ),
  );
});
kdbBankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var kdbBank = {
  category: 'brand',
  colorable: false,
  name: 'kdbBank',
  svg: kdbBankSvg,
};
